!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?n():"function"==typeof define&&define.amd?define(n):n()}(0,function(){"use strict";function e(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})}function n(e){return!(!e||"undefined"==typeof e.length)}function t(){}function o(e){if(!(this instanceof o))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],c(e,this)}function r(e,n){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,o._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null!==t){var o;try{o=t(e._value)}catch(r){return void f(n.promise,r)}i(n.promise,o)}else(1===e._state?i:f)(n.promise,e._value)})):e._deferreds.push(n)}function i(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if(n instanceof o)return e._state=3,e._value=n,void u(e);if("function"==typeof t)return void c(function(e,n){return function(){e.apply(n,arguments)}}(t,n),e)}e._state=1,e._value=n,u(e)}catch(r){f(e,r)}}function f(e,n){e._state=2,e._value=n,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var n=0,t=e._deferreds.length;t>n;n++)r(e,e._deferreds[n]);e._deferreds=null}function c(e,n){var t=!1;try{e(function(e){t||(t=!0,i(n,e))},function(e){t||(t=!0,f(n,e))})}catch(o){if(t)return;t=!0,f(n,o)}}var a=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,n){var o=new this.constructor(t);return r(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(e,n,o)),o},o.prototype["finally"]=e,o.all=function(e){return new o(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(n){r(e,n)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(n){n(e)})},o.reject=function(e){return new o(function(n,t){t(e)})},o.race=function(e){return new o(function(t,r){if(!n(e))return r(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)o.resolve(e[i]).then(t,r)})},o._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},o._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var l=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"Promise"in l?l.Promise.prototype["finally"]||(l.Promise.prototype["finally"]=e):l.Promise=o});
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (factory((global.WHATWGFetch = {})));
  }(this, (function (exports) { 'use strict';
  
    var global = (typeof self !== 'undefined' && self) || (typeof global !== 'undefined' && global);
  
    var support = {
      searchParams: 'URLSearchParams' in global,
      iterable: 'Symbol' in global && 'iterator' in Symbol,
      blob:
        'FileReader' in global &&
        'Blob' in global &&
        (function() {
          try {
            new Blob();
            return true
          } catch (e) {
            return false
          }
        })(),
      formData: 'FormData' in global,
      arrayBuffer: 'ArrayBuffer' in global
    };
  
    function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }
  
    if (support.arrayBuffer) {
      var viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
      ];
  
      var isArrayBufferView =
        ArrayBuffer.isView ||
        function(obj) {
          return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
        };
    }
  
    function normalizeName(name) {
      if (typeof name !== 'string') {
        name = String(name);
      }
      if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
        throw new TypeError('Invalid character in header field name')
      }
      return name.toLowerCase()
    }
  
    function normalizeValue(value) {
      if (typeof value !== 'string') {
        value = String(value);
      }
      return value
    }
  
    // Build a destructive iterator for the value list
    function iteratorFor(items) {
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value}
        }
      };
  
      if (support.iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator
        };
      }
  
      return iterator
    }
  
    function Headers(headers) {
      this.map = {};
  
      if (headers instanceof Headers) {
        headers.forEach(function(value, name) {
          this.append(name, value);
        }, this);
      } else if (Array.isArray(headers)) {
        headers.forEach(function(header) {
          this.append(header[0], header[1]);
        }, this);
      } else if (headers) {
        Object.getOwnPropertyNames(headers).forEach(function(name) {
          this.append(name, headers[name]);
        }, this);
      }
    }
  
    Headers.prototype.append = function(name, value) {
      name = normalizeName(name);
      value = normalizeValue(value);
      var oldValue = this.map[name];
      this.map[name] = oldValue ? oldValue + ', ' + value : value;
    };
  
    Headers.prototype['delete'] = function(name) {
      delete this.map[normalizeName(name)];
    };
  
    Headers.prototype.get = function(name) {
      name = normalizeName(name);
      return this.has(name) ? this.map[name] : null
    };
  
    Headers.prototype.has = function(name) {
      return this.map.hasOwnProperty(normalizeName(name))
    };
  
    Headers.prototype.set = function(name, value) {
      this.map[normalizeName(name)] = normalizeValue(value);
    };
  
    Headers.prototype.forEach = function(callback, thisArg) {
      for (var name in this.map) {
        if (this.map.hasOwnProperty(name)) {
          callback.call(thisArg, this.map[name], name, this);
        }
      }
    };
  
    Headers.prototype.keys = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push(name);
      });
      return iteratorFor(items)
    };
  
    Headers.prototype.values = function() {
      var items = [];
      this.forEach(function(value) {
        items.push(value);
      });
      return iteratorFor(items)
    };
  
    Headers.prototype.entries = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
      });
      return iteratorFor(items)
    };
  
    if (support.iterable) {
      Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    }
  
    function consumed(body) {
      if (body.bodyUsed) {
        return Promise.reject(new TypeError('Already read'))
      }
      body.bodyUsed = true;
    }
  
    function fileReaderReady(reader) {
      return new Promise(function(resolve, reject) {
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = function() {
          reject(reader.error);
        };
      })
    }
  
    function readBlobAsArrayBuffer(blob) {
      var reader = new FileReader();
      var promise = fileReaderReady(reader);
      reader.readAsArrayBuffer(blob);
      return promise
    }
  
    function readBlobAsText(blob) {
      var reader = new FileReader();
      var promise = fileReaderReady(reader);
      reader.readAsText(blob);
      return promise
    }
  
    function readArrayBufferAsText(buf) {
      var view = new Uint8Array(buf);
      var chars = new Array(view.length);
  
      for (var i = 0; i < view.length; i++) {
        chars[i] = String.fromCharCode(view[i]);
      }
      return chars.join('')
    }
  
    function bufferClone(buf) {
      if (buf.slice) {
        return buf.slice(0)
      } else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer
      }
    }
  
    function Body() {
      this.bodyUsed = false;
  
      this._initBody = function(body) {
        /*
          fetch-mock wraps the Response object in an ES6 Proxy to
          provide useful test harness features such as flush. However, on
          ES5 browsers without fetch or Proxy support pollyfills must be used;
          the proxy-pollyfill is unable to proxy an attribute unless it exists
          on the object before the Proxy is created. This change ensures
          Response.bodyUsed exists on the instance, while maintaining the
          semantic of setting Request.bodyUsed in the constructor before
          _initBody is called.
        */
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
          this._bodyText = '';
        } else if (typeof body === 'string') {
          this._bodyText = body;
        } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
          this._bodyBlob = body;
        } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
          this._bodyFormData = body;
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this._bodyText = body.toString();
        } else if (support.arrayBuffer && support.blob && isDataView(body)) {
          this._bodyArrayBuffer = bufferClone(body.buffer);
          // IE 10-11 can't handle a DataView body.
          this._bodyInit = new Blob([this._bodyArrayBuffer]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
          this._bodyArrayBuffer = bufferClone(body);
        } else {
          this._bodyText = body = Object.prototype.toString.call(body);
        }
  
        if (!this.headers.get('content-type')) {
          if (typeof body === 'string') {
            this.headers.set('content-type', 'text/plain;charset=UTF-8');
          } else if (this._bodyBlob && this._bodyBlob.type) {
            this.headers.set('content-type', this._bodyBlob.type);
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
          }
        }
      };
  
      if (support.blob) {
        this.blob = function() {
          var rejected = consumed(this);
          if (rejected) {
            return rejected
          }
  
          if (this._bodyBlob) {
            return Promise.resolve(this._bodyBlob)
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(new Blob([this._bodyArrayBuffer]))
          } else if (this._bodyFormData) {
            throw new Error('could not read FormData body as blob')
          } else {
            return Promise.resolve(new Blob([this._bodyText]))
          }
        };
  
        this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var isConsumed = consumed(this);
            if (isConsumed) {
              return isConsumed
            }
            if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
              return Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              )
            } else {
              return Promise.resolve(this._bodyArrayBuffer)
            }
          } else {
            return this.blob().then(readBlobAsArrayBuffer)
          }
        };
      }
  
      this.text = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }
  
        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text')
        } else {
          return Promise.resolve(this._bodyText)
        }
      };
  
      if (support.formData) {
        this.formData = function() {
          return this.text().then(decode)
        };
      }
  
      this.json = function() {
        return this.text().then(JSON.parse)
      };
  
      return this
    }
  
    // HTTP methods whose capitalization should be normalized
    var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
  
    function normalizeMethod(method) {
      var upcased = method.toUpperCase();
      return methods.indexOf(upcased) > -1 ? upcased : method
    }
  
    function Request(input, options) {
      if (!(this instanceof Request)) {
        throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
      }
  
      options = options || {};
      var body = options.body;
  
      if (input instanceof Request) {
        if (input.bodyUsed) {
          throw new TypeError('Already read')
        }
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) {
          this.headers = new Headers(input.headers);
        }
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
          body = input._bodyInit;
          input.bodyUsed = true;
        }
      } else {
        this.url = String(input);
      }
  
      this.credentials = options.credentials || this.credentials || 'same-origin';
      if (options.headers || !this.headers) {
        this.headers = new Headers(options.headers);
      }
      this.method = normalizeMethod(options.method || this.method || 'GET');
      this.mode = options.mode || this.mode || null;
      this.signal = options.signal || this.signal;
      this.referrer = null;
  
      if ((this.method === 'GET' || this.method === 'HEAD') && body) {
        throw new TypeError('Body not allowed for GET or HEAD requests')
      }
      this._initBody(body);
  
      if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
          // Search for a '_' parameter in the query string
          var reParamSearch = /([?&])_=[^&]*/;
          if (reParamSearch.test(this.url)) {
            // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
          } else {
            // Otherwise add a new '_' parameter to the end with the current time
            var reQueryString = /\?/;
            this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
          }
        }
      }
    }
  
    Request.prototype.clone = function() {
      return new Request(this, {body: this._bodyInit})
    };
  
    function decode(body) {
      var form = new FormData();
      body
        .trim()
        .split('&')
        .forEach(function(bytes) {
          if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
          }
        });
      return form
    }
  
    function parseHeaders(rawHeaders) {
      var headers = new Headers();
      // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
      // https://tools.ietf.org/html/rfc7230#section-3.2
      var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
      preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
      return headers
    }
  
    Body.call(Request.prototype);
  
    function Response(bodyInit, options) {
      if (!(this instanceof Response)) {
        throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
      }
      if (!options) {
        options = {};
      }
  
      this.type = 'default';
      this.status = options.status === undefined ? 200 : options.status;
      this.ok = this.status >= 200 && this.status < 300;
      this.statusText = 'statusText' in options ? options.statusText : '';
      this.headers = new Headers(options.headers);
      this.url = options.url || '';
      this._initBody(bodyInit);
    }
  
    Body.call(Response.prototype);
  
    Response.prototype.clone = function() {
      return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
      })
    };
  
    Response.error = function() {
      var response = new Response(null, {status: 0, statusText: ''});
      response.type = 'error';
      return response
    };
  
    var redirectStatuses = [301, 302, 303, 307, 308];
  
    Response.redirect = function(url, status) {
      if (redirectStatuses.indexOf(status) === -1) {
        throw new RangeError('Invalid status code')
      }
  
      return new Response(null, {status: status, headers: {location: url}})
    };
  
    exports.DOMException = global.DOMException;
    try {
      new exports.DOMException();
    } catch (err) {
      exports.DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
      };
      exports.DOMException.prototype = Object.create(Error.prototype);
      exports.DOMException.prototype.constructor = exports.DOMException;
    }
  
    function fetch(input, init) {
      return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
  
        if (request.signal && request.signal.aborted) {
          return reject(new exports.DOMException('Aborted', 'AbortError'))
        }
  
        var xhr = new XMLHttpRequest();
  
        function abortXhr() {
          xhr.abort();
        }
  
        xhr.onload = function() {
          var options = {
            status: xhr.status,
            statusText: xhr.statusText,
            headers: parseHeaders(xhr.getAllResponseHeaders() || '')
          };
          options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
          var body = 'response' in xhr ? xhr.response : xhr.responseText;
          setTimeout(function() {
            resolve(new Response(body, options));
          }, 0);
        };
  
        xhr.onerror = function() {
          setTimeout(function() {
            reject(new TypeError('Network request failed'));
          }, 0);
        };
  
        xhr.ontimeout = function() {
          setTimeout(function() {
            reject(new TypeError('Network request failed'));
          }, 0);
        };
  
        xhr.onabort = function() {
          setTimeout(function() {
            reject(new exports.DOMException('Aborted', 'AbortError'));
          }, 0);
        };
  
        function fixUrl(url) {
          try {
            return url === '' && global.location.href ? global.location.href : url
          } catch (e) {
            return url
          }
        }
  
        xhr.open(request.method, fixUrl(request.url), true);
  
        if (request.credentials === 'include') {
          xhr.withCredentials = true;
        } else if (request.credentials === 'omit') {
          xhr.withCredentials = false;
        }
  
        if ('responseType' in xhr) {
          if (support.blob) {
            xhr.responseType = 'blob';
          } else if (
            support.arrayBuffer &&
            request.headers.get('Content-Type') &&
            request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
          ) {
            xhr.responseType = 'arraybuffer';
          }
        }
  
        if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
          Object.getOwnPropertyNames(init.headers).forEach(function(name) {
            xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
          });
        } else {
          request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
          });
        }
  
        if (request.signal) {
          request.signal.addEventListener('abort', abortXhr);
  
          xhr.onreadystatechange = function() {
            // DONE (success or failure)
            if (xhr.readyState === 4) {
              request.signal.removeEventListener('abort', abortXhr);
            }
          };
        }
  
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
      })
    }
  
    fetch.polyfill = true;
  
    if (!global.fetch) {
      global.fetch = fetch;
      global.Headers = Headers;
      global.Request = Request;
      global.Response = Response;
    }
  
    exports.Headers = Headers;
    exports.Request = Request;
    exports.Response = Response;
    exports.fetch = fetch;
  
    Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
    'use strict';
    
    // Exit early if we're not running in a browser.
    if (typeof window !== 'object') {
      return;
    }
    
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    
      // Minimal polyfill for Edge 15's lack of `isIntersecting`
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype,
          'isIntersecting', {
          get: function () {
            return this.intersectionRatio > 0;
          }
        });
      }
      return;
    }
    
    /**
     * Returns the embedding frame element, if any.
     * @param {!Document} doc
     * @return {!Element}
     */
    function getFrameElement(doc) {
      try {
        return doc.defaultView && doc.defaultView.frameElement || null;
      } catch (e) {
        // Ignore the error.
        return null;
      }
    }
    
    /**
     * A local reference to the root document.
     */
    var document = (function(startDoc) {
      var doc = startDoc;
      var frame = getFrameElement(doc);
      while (frame) {
        doc = frame.ownerDocument;
        frame = getFrameElement(doc);
      }
      return doc;
    })(window.document);
    
    /**
     * An IntersectionObserver registry. This registry exists to hold a strong
     * reference to IntersectionObserver instances currently observing a target
     * element. Without this registry, instances without another reference may be
     * garbage collected.
     */
    var registry = [];
    
    /**
     * The signal updater for cross-origin intersection. When not null, it means
     * that the polyfill is configured to work in a cross-origin mode.
     * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
     */
    var crossOriginUpdater = null;
    
    /**
     * The current cross-origin intersection. Only used in the cross-origin mode.
     * @type {DOMRect|ClientRect}
     */
    var crossOriginRect = null;
    
    
    /**
     * Creates the global IntersectionObserverEntry constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
     * @param {Object} entry A dictionary of instance properties.
     * @constructor
     */
    function IntersectionObserverEntry(entry) {
      this.time = entry.time;
      this.target = entry.target;
      this.rootBounds = ensureDOMRect(entry.rootBounds);
      this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
      this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
      this.isIntersecting = !!entry.intersectionRect;
    
      // Calculates the intersection ratio.
      var targetRect = this.boundingClientRect;
      var targetArea = targetRect.width * targetRect.height;
      var intersectionRect = this.intersectionRect;
      var intersectionArea = intersectionRect.width * intersectionRect.height;
    
      // Sets intersection ratio.
      if (targetArea) {
        // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
      } else {
        // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
      }
    }
    
    
    /**
     * Creates the global IntersectionObserver constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
     * @param {Function} callback The function to be invoked after intersection
     *     changes have queued. The function is not invoked if the queue has
     *     been emptied by calling the `takeRecords` method.
     * @param {Object=} opt_options Optional configuration options.
     * @constructor
     */
    function IntersectionObserver(callback, opt_options) {
    
      var options = opt_options || {};
    
      if (typeof callback != 'function') {
        throw new Error('callback must be a function');
      }
    
      if (options.root && options.root.nodeType != 1) {
        throw new Error('root must be an Element');
      }
    
      // Binds and throttles `this._checkForIntersections`.
      this._checkForIntersections = throttle(
          this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
    
      // Private properties.
      this._callback = callback;
      this._observationTargets = [];
      this._queuedEntries = [];
      this._rootMarginValues = this._parseRootMargin(options.rootMargin);
    
      // Public properties.
      this.thresholds = this._initThresholds(options.threshold);
      this.root = options.root || null;
      this.rootMargin = this._rootMarginValues.map(function(margin) {
        return margin.value + margin.unit;
      }).join(' ');
    
      /** @private @const {!Array<!Document>} */
      this._monitoringDocuments = [];
      /** @private @const {!Array<function()>} */
      this._monitoringUnsubscribes = [];
    }
    
    
    /**
     * The minimum interval within which the document will be checked for
     * intersection changes.
     */
    IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    
    
    /**
     * The frequency in which the polyfill polls for intersection changes.
     * this can be updated on a per instance basis and must be set prior to
     * calling `observe` on the first target.
     */
    IntersectionObserver.prototype.POLL_INTERVAL = null;
    
    /**
     * Use a mutation observer on the root element
     * to detect intersection changes.
     */
    IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    
    
    /**
     * Sets up the polyfill in the cross-origin mode. The result is the
     * updater function that accepts two arguments: `boundingClientRect` and
     * `intersectionRect` - just as these fields would be available to the
     * parent via `IntersectionObserverEntry`. This function should be called
     * each time the iframe receives intersection information from the parent
     * window, e.g. via messaging.
     * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
     */
    IntersectionObserver._setupCrossOriginUpdater = function() {
      if (!crossOriginUpdater) {
        /**
         * @param {DOMRect|ClientRect} boundingClientRect
         * @param {DOMRect|ClientRect} intersectionRect
         */
        crossOriginUpdater = function(boundingClientRect, intersectionRect) {
          if (!boundingClientRect || !intersectionRect) {
            crossOriginRect = getEmptyRect();
          } else {
            crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
          }
          registry.forEach(function(observer) {
            observer._checkForIntersections();
          });
        };
      }
      return crossOriginUpdater;
    };
    
    
    /**
     * Resets the cross-origin mode.
     */
    IntersectionObserver._resetCrossOriginUpdater = function() {
      crossOriginUpdater = null;
      crossOriginRect = null;
    };
    
    
    /**
     * Starts observing a target element for intersection changes based on
     * the thresholds values.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.observe = function(target) {
      var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
        return item.element == target;
      });
    
      if (isTargetAlreadyObserved) {
        return;
      }
    
      if (!(target && target.nodeType == 1)) {
        throw new Error('target must be an Element');
      }
    
      this._registerInstance();
      this._observationTargets.push({element: target, entry: null});
      this._monitorIntersections(target.ownerDocument);
      this._checkForIntersections();
    };
    
    
    /**
     * Stops observing a target element for intersection changes.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.unobserve = function(target) {
      this._observationTargets =
          this._observationTargets.filter(function(item) {
            return item.element != target;
          });
      this._unmonitorIntersections(target.ownerDocument);
      if (this._observationTargets.length == 0) {
        this._unregisterInstance();
      }
    };
    
    
    /**
     * Stops observing all target elements for intersection changes.
     */
    IntersectionObserver.prototype.disconnect = function() {
      this._observationTargets = [];
      this._unmonitorAllIntersections();
      this._unregisterInstance();
    };
    
    
    /**
     * Returns any queue entries that have not yet been reported to the
     * callback and clears the queue. This can be used in conjunction with the
     * callback to obtain the absolute most up-to-date intersection information.
     * @return {Array} The currently queued entries.
     */
    IntersectionObserver.prototype.takeRecords = function() {
      var records = this._queuedEntries.slice();
      this._queuedEntries = [];
      return records;
    };
    
    
    /**
     * Accepts the threshold value from the user configuration object and
     * returns a sorted array of unique threshold values. If a value is not
     * between 0 and 1 and error is thrown.
     * @private
     * @param {Array|number=} opt_threshold An optional threshold value or
     *     a list of threshold values, defaulting to [0].
     * @return {Array} A sorted list of unique and valid threshold values.
     */
    IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
      var threshold = opt_threshold || [0];
      if (!Array.isArray(threshold)) threshold = [threshold];
    
      return threshold.sort().filter(function(t, i, a) {
        if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
          throw new Error('threshold must be a number between 0 and 1 inclusively');
        }
        return t !== a[i - 1];
      });
    };
    
    
    /**
     * Accepts the rootMargin value from the user configuration object
     * and returns an array of the four margin values as an object containing
     * the value and unit properties. If any of the values are not properly
     * formatted or use a unit other than px or %, and error is thrown.
     * @private
     * @param {string=} opt_rootMargin An optional rootMargin value,
     *     defaulting to '0px'.
     * @return {Array<Object>} An array of margin objects with the keys
     *     value and unit.
     */
    IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
      var marginString = opt_rootMargin || '0px';
      var margins = marginString.split(/\s+/).map(function(margin) {
        var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
        if (!parts) {
          throw new Error('rootMargin must be specified in pixels or percent');
        }
        return {value: parseFloat(parts[1]), unit: parts[2]};
      });
    
      // Handles shorthand.
      margins[1] = margins[1] || margins[0];
      margins[2] = margins[2] || margins[0];
      margins[3] = margins[3] || margins[1];
    
      return margins;
    };
    
    
    /**
     * Starts polling for intersection changes if the polling is not already
     * happening, and if the page's visibility state is visible.
     * @param {!Document} doc
     * @private
     */
    IntersectionObserver.prototype._monitorIntersections = function(doc) {
      var win = doc.defaultView;
      if (!win) {
        // Already destroyed.
        return;
      }
      if (this._monitoringDocuments.indexOf(doc) != -1) {
        // Already monitoring.
        return;
      }
    
      // Private state for monitoring.
      var callback = this._checkForIntersections;
      var monitoringInterval = null;
      var domObserver = null;
    
      // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.
      if (this.POLL_INTERVAL) {
        monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
      } else {
        addEvent(win, 'resize', callback, true);
        addEvent(doc, 'scroll', callback, true);
        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
          domObserver = new win.MutationObserver(callback);
          domObserver.observe(doc, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    
      this._monitoringDocuments.push(doc);
      this._monitoringUnsubscribes.push(function() {
        // Get the window object again. When a friendly iframe is destroyed, it
        // will be null.
        var win = doc.defaultView;
    
        if (win) {
          if (monitoringInterval) {
            win.clearInterval(monitoringInterval);
          }
          removeEvent(win, 'resize', callback, true);
        }
    
        removeEvent(doc, 'scroll', callback, true);
        if (domObserver) {
          domObserver.disconnect();
        }
      });
    
      // Also monitor the parent.
      if (doc != (this.root && this.root.ownerDocument || document)) {
        var frame = getFrameElement(doc);
        if (frame) {
          this._monitorIntersections(frame.ownerDocument);
        }
      }
    };
    
    
    /**
     * Stops polling for intersection changes.
     * @param {!Document} doc
     * @private
     */
    IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
      var index = this._monitoringDocuments.indexOf(doc);
      if (index == -1) {
        return;
      }
    
      var rootDoc = (this.root && this.root.ownerDocument || document);
    
      // Check if any dependent targets are still remaining.
      var hasDependentTargets =
          this._observationTargets.some(function(item) {
            var itemDoc = item.element.ownerDocument;
            // Target is in this context.
            if (itemDoc == doc) {
              return true;
            }
            // Target is nested in this context.
            while (itemDoc && itemDoc != rootDoc) {
              var frame = getFrameElement(itemDoc);
              itemDoc = frame && frame.ownerDocument;
              if (itemDoc == doc) {
                return true;
              }
            }
            return false;
          });
      if (hasDependentTargets) {
        return;
      }
    
      // Unsubscribe.
      var unsubscribe = this._monitoringUnsubscribes[index];
      this._monitoringDocuments.splice(index, 1);
      this._monitoringUnsubscribes.splice(index, 1);
      unsubscribe();
    
      // Also unmonitor the parent.
      if (doc != rootDoc) {
        var frame = getFrameElement(doc);
        if (frame) {
          this._unmonitorIntersections(frame.ownerDocument);
        }
      }
    };
    
    
    /**
     * Stops polling for intersection changes.
     * @param {!Document} doc
     * @private
     */
    IntersectionObserver.prototype._unmonitorAllIntersections = function() {
      var unsubscribes = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0;
      this._monitoringUnsubscribes.length = 0;
      for (var i = 0; i < unsubscribes.length; i++) {
        unsubscribes[i]();
      }
    };
    
    
    /**
     * Scans each observation target for intersection changes and adds them
     * to the internal entries queue. If new entries are found, it
     * schedules the callback to be invoked.
     * @private
     */
    IntersectionObserver.prototype._checkForIntersections = function() {
      if (!this.root && crossOriginUpdater && !crossOriginRect) {
        // Cross origin monitoring, but no initial data available yet.
        return;
      }
    
      var rootIsInDom = this._rootIsInDom();
      var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
    
      this._observationTargets.forEach(function(item) {
        var target = item.element;
        var targetRect = getBoundingClientRect(target);
        var rootContainsTarget = this._rootContainsTarget(target);
        var oldEntry = item.entry;
        var intersectionRect = rootIsInDom && rootContainsTarget &&
            this._computeTargetAndRootIntersection(target, targetRect, rootRect);
    
        var newEntry = item.entry = new IntersectionObserverEntry({
          time: now(),
          target: target,
          boundingClientRect: targetRect,
          rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
          intersectionRect: intersectionRect
        });
    
        if (!oldEntry) {
          this._queuedEntries.push(newEntry);
        } else if (rootIsInDom && rootContainsTarget) {
          // If the new entry intersection ratio has crossed any of the
          // thresholds, add a new entry.
          if (this._hasCrossedThreshold(oldEntry, newEntry)) {
            this._queuedEntries.push(newEntry);
          }
        } else {
          // If the root is not in the DOM or target is not contained within
          // root but the previous entry for this target had an intersection,
          // add a new record indicating removal.
          if (oldEntry && oldEntry.isIntersecting) {
            this._queuedEntries.push(newEntry);
          }
        }
      }, this);
    
      if (this._queuedEntries.length) {
        this._callback(this.takeRecords(), this);
      }
    };
    
    
    /**
     * Accepts a target and root rect computes the intersection between then
     * following the algorithm in the spec.
     * TODO(philipwalton): at this time clip-path is not considered.
     * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
     * @param {Element} target The target DOM element
     * @param {Object} targetRect The bounding rect of the target.
     * @param {Object} rootRect The bounding rect of the root after being
     *     expanded by the rootMargin value.
     * @return {?Object} The final intersection rect object or undefined if no
     *     intersection is found.
     * @private
     */
    IntersectionObserver.prototype._computeTargetAndRootIntersection =
        function(target, targetRect, rootRect) {
      // If the element isn't displayed, an intersection can't happen.
      if (window.getComputedStyle(target).display == 'none') return;
    
      var intersectionRect = targetRect;
      var parent = getParentNode(target);
      var atRoot = false;
    
      while (!atRoot && parent) {
        var parentRect = null;
        var parentComputedStyle = parent.nodeType == 1 ?
            window.getComputedStyle(parent) : {};
    
        // If the parent isn't displayed, an intersection can't happen.
        if (parentComputedStyle.display == 'none') return null;
    
        if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
          atRoot = true;
          if (parent == this.root || parent == document) {
            if (crossOriginUpdater && !this.root) {
              if (!crossOriginRect ||
                  crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                // A 0-size cross-origin intersection means no-intersection.
                parent = null;
                parentRect = null;
                intersectionRect = null;
              } else {
                parentRect = crossOriginRect;
              }
            } else {
              parentRect = rootRect;
            }
          } else {
            // Check if there's a frame that can be navigated to.
            var frame = getParentNode(parent);
            var frameRect = frame && getBoundingClientRect(frame);
            var frameIntersect =
                frame &&
                this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
            if (frameRect && frameIntersect) {
              parent = frame;
              parentRect = convertFromParentRect(frameRect, frameIntersect);
            } else {
              parent = null;
              intersectionRect = null;
            }
          }
        } else {
          // If the element has a non-visible overflow, and it's not the <body>
          // or <html> element, update the intersection rect.
          // Note: <body> and <html> cannot be clipped to a rect that's not also
          // the document rect, so no need to compute a new intersection.
          var doc = parent.ownerDocument;
          if (parent != doc.body &&
              parent != doc.documentElement &&
              parentComputedStyle.overflow != 'visible') {
            parentRect = getBoundingClientRect(parent);
          }
        }
    
        // If either of the above conditionals set a new parentRect,
        // calculate new intersection data.
        if (parentRect) {
          intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        }
        if (!intersectionRect) break;
        parent = parent && getParentNode(parent);
      }
      return intersectionRect;
    };
    
    
    /**
     * Returns the root rect after being expanded by the rootMargin value.
     * @return {ClientRect} The expanded root rect.
     * @private
     */
    IntersectionObserver.prototype._getRootRect = function() {
      var rootRect;
      if (this.root) {
        rootRect = getBoundingClientRect(this.root);
      } else {
        // Use <html>/<body> instead of window since scroll bars affect size.
        var html = document.documentElement;
        var body = document.body;
        rootRect = {
          top: 0,
          left: 0,
          right: html.clientWidth || body.clientWidth,
          width: html.clientWidth || body.clientWidth,
          bottom: html.clientHeight || body.clientHeight,
          height: html.clientHeight || body.clientHeight
        };
      }
      return this._expandRectByRootMargin(rootRect);
    };
    
    
    /**
     * Accepts a rect and expands it by the rootMargin value.
     * @param {DOMRect|ClientRect} rect The rect object to expand.
     * @return {ClientRect} The expanded rect.
     * @private
     */
    IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
      var margins = this._rootMarginValues.map(function(margin, i) {
        return margin.unit == 'px' ? margin.value :
            margin.value * (i % 2 ? rect.width : rect.height) / 100;
      });
      var newRect = {
        top: rect.top - margins[0],
        right: rect.right + margins[1],
        bottom: rect.bottom + margins[2],
        left: rect.left - margins[3]
      };
      newRect.width = newRect.right - newRect.left;
      newRect.height = newRect.bottom - newRect.top;
    
      return newRect;
    };
    
    
    /**
     * Accepts an old and new entry and returns true if at least one of the
     * threshold values has been crossed.
     * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
     *    particular target element or null if no previous entry exists.
     * @param {IntersectionObserverEntry} newEntry The current entry for a
     *    particular target element.
     * @return {boolean} Returns true if a any threshold has been crossed.
     * @private
     */
    IntersectionObserver.prototype._hasCrossedThreshold =
        function(oldEntry, newEntry) {
    
      // To make comparing easier, an entry that has a ratio of 0
      // but does not actually intersect is given a value of -1
      var oldRatio = oldEntry && oldEntry.isIntersecting ?
          oldEntry.intersectionRatio || 0 : -1;
      var newRatio = newEntry.isIntersecting ?
          newEntry.intersectionRatio || 0 : -1;
    
      // Ignore unchanged ratios
      if (oldRatio === newRatio) return;
    
      for (var i = 0; i < this.thresholds.length; i++) {
        var threshold = this.thresholds[i];
    
        // Return true if an entry matches a threshold or if the new ratio
        // and the old ratio are on the opposite sides of a threshold.
        if (threshold == oldRatio || threshold == newRatio ||
            threshold < oldRatio !== threshold < newRatio) {
          return true;
        }
      }
    };
    
    
    /**
     * Returns whether or not the root element is an element and is in the DOM.
     * @return {boolean} True if the root element is an element and is in the DOM.
     * @private
     */
    IntersectionObserver.prototype._rootIsInDom = function() {
      return !this.root || containsDeep(document, this.root);
    };
    
    
    /**
     * Returns whether or not the target element is a child of root.
     * @param {Element} target The target element to check.
     * @return {boolean} True if the target element is a child of root.
     * @private
     */
    IntersectionObserver.prototype._rootContainsTarget = function(target) {
      return containsDeep(this.root || document, target) &&
        (!this.root || this.root.ownerDocument == target.ownerDocument);
    };
    
    
    /**
     * Adds the instance to the global IntersectionObserver registry if it isn't
     * already present.
     * @private
     */
    IntersectionObserver.prototype._registerInstance = function() {
      if (registry.indexOf(this) < 0) {
        registry.push(this);
      }
    };
    
    
    /**
     * Removes the instance from the global IntersectionObserver registry.
     * @private
     */
    IntersectionObserver.prototype._unregisterInstance = function() {
      var index = registry.indexOf(this);
      if (index != -1) registry.splice(index, 1);
    };
    
    
    /**
     * Returns the result of the performance.now() method or null in browsers
     * that don't support the API.
     * @return {number} The elapsed time since the page was requested.
     */
    function now() {
      return window.performance && performance.now && performance.now();
    }
    
    
    /**
     * Throttles a function and delays its execution, so it's only called at most
     * once within a given time period.
     * @param {Function} fn The function to throttle.
     * @param {number} timeout The amount of time that must pass before the
     *     function can be called again.
     * @return {Function} The throttled function.
     */
    function throttle(fn, timeout) {
      var timer = null;
      return function () {
        if (!timer) {
          timer = setTimeout(function() {
            fn();
            timer = null;
          }, timeout);
        }
      };
    }
    
    
    /**
     * Adds an event handler to a DOM node ensuring cross-browser compatibility.
     * @param {Node} node The DOM node to add the event handler to.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to add.
     * @param {boolean} opt_useCapture Optionally adds the even to the capture
     *     phase. Note: this only works in modern browsers.
     */
    function addEvent(node, event, fn, opt_useCapture) {
      if (typeof node.addEventListener == 'function') {
        node.addEventListener(event, fn, opt_useCapture || false);
      }
      else if (typeof node.attachEvent == 'function') {
        node.attachEvent('on' + event, fn);
      }
    }
    
    
    /**
     * Removes a previously added event handler from a DOM node.
     * @param {Node} node The DOM node to remove the event handler from.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} opt_useCapture If the event handler was added with this
     *     flag set to true, it should be set to true here in order to remove it.
     */
    function removeEvent(node, event, fn, opt_useCapture) {
      if (typeof node.removeEventListener == 'function') {
        node.removeEventListener(event, fn, opt_useCapture || false);
      }
      else if (typeof node.detatchEvent == 'function') {
        node.detatchEvent('on' + event, fn);
      }
    }
    
    
    /**
     * Returns the intersection between two rect objects.
     * @param {Object} rect1 The first rect.
     * @param {Object} rect2 The second rect.
     * @return {?Object|?ClientRect} The intersection rect or undefined if no
     *     intersection is found.
     */
    function computeRectIntersection(rect1, rect2) {
      var top = Math.max(rect1.top, rect2.top);
      var bottom = Math.min(rect1.bottom, rect2.bottom);
      var left = Math.max(rect1.left, rect2.left);
      var right = Math.min(rect1.right, rect2.right);
      var width = right - left;
      var height = bottom - top;
    
      return (width >= 0 && height >= 0) && {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height
      } || null;
    }
    
    
    /**
     * Shims the native getBoundingClientRect for compatibility with older IE.
     * @param {Element} el The element whose bounding rect to get.
     * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
     */
    function getBoundingClientRect(el) {
      var rect;
    
      try {
        rect = el.getBoundingClientRect();
      } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
      }
    
      if (!rect) return getEmptyRect();
    
      // Older IE
      if (!(rect.width && rect.height)) {
        rect = {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };
      }
      return rect;
    }
    
    
    /**
     * Returns an empty rect object. An empty rect is returned when an element
     * is not in the DOM.
     * @return {ClientRect} The empty rect.
     */
    function getEmptyRect() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    
    
    /**
     * Ensure that the result has all of the necessary fields of the DOMRect.
     * Specifically this ensures that `x` and `y` fields are set.
     *
     * @param {?DOMRect|?ClientRect} rect
     * @return {?DOMRect}
     */
    function ensureDOMRect(rect) {
      // A `DOMRect` object has `x` and `y` fields.
      if (!rect || 'x' in rect) {
        return rect;
      }
      // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
      // for internally calculated Rect objects. For the purposes of
      // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
      // for these fields.
      return {
        top: rect.top,
        y: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        x: rect.left,
        right: rect.right,
        width: rect.width,
        height: rect.height
      };
    }
    
    
    /**
     * Inverts the intersection and bounding rect from the parent (frame) BCR to
     * the local BCR space.
     * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
     * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
     * @return {ClientRect} The local root bounding rect for the parent's children.
     */
    function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
      var top = parentIntersectionRect.top - parentBoundingRect.top;
      var left = parentIntersectionRect.left - parentBoundingRect.left;
      return {
        top: top,
        left: left,
        height: parentIntersectionRect.height,
        width: parentIntersectionRect.width,
        bottom: top + parentIntersectionRect.height,
        right: left + parentIntersectionRect.width
      };
    }
    
    
    /**
     * Checks to see if a parent element contains a child element (including inside
     * shadow DOM).
     * @param {Node} parent The parent element.
     * @param {Node} child The child element.
     * @return {boolean} True if the parent node contains the child node.
     */
    function containsDeep(parent, child) {
      var node = child;
      while (node) {
        if (node == parent) return true;
    
        node = getParentNode(node);
      }
      return false;
    }
    
    
    /**
     * Gets the parent node of an element or its host element if the parent node
     * is a shadow root.
     * @param {Node} node The node whose parent to get.
     * @return {Node|null} The parent node or null if no parent exists.
     */
    function getParentNode(node) {
      var parent = node.parentNode;
    
      if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
        // If this node is a document node, look for the embedding frame.
        return getFrameElement(node);
      }
    
      if (parent && parent.nodeType == 11 && parent.host) {
        // If the parent is a shadow root, return the host element.
        return parent.host;
      }
    
      if (parent && parent.assignedSlot) {
        // If the parent is distributed in a <slot>, return the parent of a slot.
        return parent.assignedSlot.parentNode;
      }
    
      return parent;
    }
    
    
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
    
    }());
var tns=function(){var t=window,Hi=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)},e=window,Oi=e.cancelAnimationFrame||e.mozCancelAnimationFrame||function(t){clearTimeout(t)};function Di(){for(var t,e,n,i=arguments[0]||{},a=1,r=arguments.length;a<r;a++)if(null!==(t=arguments[a]))for(e in t)i!==(n=t[e])&&void 0!==n&&(i[e]=n);return i}function ki(t){return 0<=["true","false"].indexOf(t)?JSON.parse(t):t}function Ri(t,e,n,i){if(i)try{t.setItem(e,n)}catch(t){}return n}function Ii(){var t=document,e=t.body;return e||((e=t.createElement("body")).fake=!0),e}var n=document.documentElement;function Pi(t){var e="";return t.fake&&(e=n.style.overflow,t.style.background="",t.style.overflow=n.style.overflow="hidden",n.appendChild(t)),e}function zi(t,e){t.fake&&(t.remove(),n.style.overflow=e,n.offsetHeight)}function Wi(t,e,n,i){"insertRule"in t?t.insertRule(e+"{"+n+"}",i):t.addRule(e,n,i)}function qi(t){return("insertRule"in t?t.cssRules:t.rules).length}function Fi(t,e,n){for(var i=0,a=t.length;i<a;i++)e.call(n,t[i],i)}var i="classList"in document.createElement("_"),ji=i?function(t,e){return t.classList.contains(e)}:function(t,e){return 0<=t.className.indexOf(e)},Vi=i?function(t,e){ji(t,e)||t.classList.add(e)}:function(t,e){ji(t,e)||(t.className+=" "+e)},Gi=i?function(t,e){ji(t,e)&&t.classList.remove(e)}:function(t,e){ji(t,e)&&(t.className=t.className.replace(e,""))};function Qi(t,e){return t.hasAttribute(e)}function Xi(t,e){return t.getAttribute(e)}function r(t){return void 0!==t.item}function Yi(t,e){if(t=r(t)||t instanceof Array?t:[t],"[object Object]"===Object.prototype.toString.call(e))for(var n=t.length;n--;)for(var i in e)t[n].setAttribute(i,e[i])}function Ki(t,e){t=r(t)||t instanceof Array?t:[t];for(var n=(e=e instanceof Array?e:[e]).length,i=t.length;i--;)for(var a=n;a--;)t[i].removeAttribute(e[a])}function Ji(t){for(var e=[],n=0,i=t.length;n<i;n++)e.push(t[n]);return e}function Ui(t,e){"none"!==t.style.display&&(t.style.display="none")}function _i(t,e){"none"===t.style.display&&(t.style.display="")}function Zi(t){return"none"!==window.getComputedStyle(t).display}function $i(e){if("string"==typeof e){var n=[e],i=e.charAt(0).toUpperCase()+e.substr(1);["Webkit","Moz","ms","O"].forEach(function(t){"ms"===t&&"transform"!==e||n.push(t+i)}),e=n}for(var t=document.createElement("fakeelement"),a=(e.length,0);a<e.length;a++){var r=e[a];if(void 0!==t.style[r])return r}return!1}function ta(t,e){var n=!1;return/^Webkit/.test(t)?n="webkit"+e+"End":/^O/.test(t)?n="o"+e+"End":t&&(n=e.toLowerCase()+"end"),n}var a=!1;try{var o=Object.defineProperty({},"passive",{get:function(){a=!0}});window.addEventListener("test",null,o)}catch(t){}var u=!!a&&{passive:!0};function ea(t,e,n){for(var i in e){var a=0<=["touchstart","touchmove"].indexOf(i)&&!n&&u;t.addEventListener(i,e[i],a)}}function na(t,e){for(var n in e){var i=0<=["touchstart","touchmove"].indexOf(n)&&u;t.removeEventListener(n,e[n],i)}}function ia(){return{topics:{},on:function(t,e){this.topics[t]=this.topics[t]||[],this.topics[t].push(e)},off:function(t,e){if(this.topics[t])for(var n=0;n<this.topics[t].length;n++)if(this.topics[t][n]===e){this.topics[t].splice(n,1);break}},emit:function(e,n){n.type=e,this.topics[e]&&this.topics[e].forEach(function(t){t(n,e)})}}}Object.keys||(Object.keys=function(t){var e=[];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&e.push(n);return e}),"remove"in Element.prototype||(Element.prototype.remove=function(){this.parentNode&&this.parentNode.removeChild(this)});var aa=function(H){H=Di({container:".slider",mode:"carousel",axis:"horizontal",items:1,gutter:0,edgePadding:0,fixedWidth:!1,autoWidth:!1,viewportMax:!1,slideBy:1,center:!1,controls:!0,controlsPosition:"top",controlsText:["prev","next"],controlsContainer:!1,prevButton:!1,nextButton:!1,nav:!0,navPosition:"top",navContainer:!1,navAsThumbnails:!1,arrowKeys:!1,speed:300,autoplay:!1,autoplayPosition:"top",autoplayTimeout:5e3,autoplayDirection:"forward",autoplayText:["start","stop"],autoplayHoverPause:!1,autoplayButton:!1,autoplayButtonOutput:!0,autoplayResetOnVisibility:!0,animateIn:"tns-fadeIn",animateOut:"tns-fadeOut",animateNormal:"tns-normal",animateDelay:!1,loop:!0,rewind:!1,autoHeight:!1,responsive:!1,lazyload:!1,lazyloadSelector:".tns-lazy-img",touch:!0,mouseDrag:!1,swipeAngle:15,nested:!1,preventActionWhenRunning:!1,preventScrollOnTouch:!1,freezable:!0,onInit:!1,useLocalStorage:!0},H||{});var O=document,m=window,a={ENTER:13,SPACE:32,LEFT:37,RIGHT:39},e={},n=H.useLocalStorage;if(n){var t=navigator.userAgent,i=new Date;try{(e=m.localStorage)?(e.setItem(i,i),n=e.getItem(i)==i,e.removeItem(i)):n=!1,n||(e={})}catch(t){n=!1}n&&(e.tnsApp&&e.tnsApp!==t&&["tC","tPL","tMQ","tTf","t3D","tTDu","tTDe","tADu","tADe","tTE","tAE"].forEach(function(t){e.removeItem(t)}),localStorage.tnsApp=t)}var r,o,u,l,s,c,f,y=e.tC?ki(e.tC):Ri(e,"tC",function(){var t=document,e=Ii(),n=Pi(e),i=t.createElement("div"),a=!1;e.appendChild(i);try{for(var r,o="(10px * 10)",u=["calc"+o,"-moz-calc"+o,"-webkit-calc"+o],l=0;l<3;l++)if(r=u[l],i.style.width=r,100===i.offsetWidth){a=r.replace(o,"");break}}catch(t){}return e.fake?zi(e,n):i.remove(),a}(),n),g=e.tPL?ki(e.tPL):Ri(e,"tPL",function(){var t,e=document,n=Ii(),i=Pi(n),a=e.createElement("div"),r=e.createElement("div"),o="";a.className="tns-t-subp2",r.className="tns-t-ct";for(var u=0;u<70;u++)o+="<div></div>";return r.innerHTML=o,a.appendChild(r),n.appendChild(a),t=Math.abs(a.getBoundingClientRect().left-r.children[67].getBoundingClientRect().left)<2,n.fake?zi(n,i):a.remove(),t}(),n),D=e.tMQ?ki(e.tMQ):Ri(e,"tMQ",(o=document,u=Ii(),l=Pi(u),s=o.createElement("div"),c=o.createElement("style"),f="@media all and (min-width:1px){.tns-mq-test{position:absolute}}",c.type="text/css",s.className="tns-mq-test",u.appendChild(c),u.appendChild(s),c.styleSheet?c.styleSheet.cssText=f:c.appendChild(o.createTextNode(f)),r=window.getComputedStyle?window.getComputedStyle(s).position:s.currentStyle.position,u.fake?zi(u,l):s.remove(),"absolute"===r),n),d=e.tTf?ki(e.tTf):Ri(e,"tTf",$i("transform"),n),v=e.t3D?ki(e.t3D):Ri(e,"t3D",function(t){if(!t)return!1;if(!window.getComputedStyle)return!1;var e,n=document,i=Ii(),a=Pi(i),r=n.createElement("p"),o=9<t.length?"-"+t.slice(0,-9).toLowerCase()+"-":"";return o+="transform",i.insertBefore(r,null),r.style[t]="translate3d(1px,1px,1px)",e=window.getComputedStyle(r).getPropertyValue(o),i.fake?zi(i,a):r.remove(),void 0!==e&&0<e.length&&"none"!==e}(d),n),x=e.tTDu?ki(e.tTDu):Ri(e,"tTDu",$i("transitionDuration"),n),p=e.tTDe?ki(e.tTDe):Ri(e,"tTDe",$i("transitionDelay"),n),b=e.tADu?ki(e.tADu):Ri(e,"tADu",$i("animationDuration"),n),h=e.tADe?ki(e.tADe):Ri(e,"tADe",$i("animationDelay"),n),C=e.tTE?ki(e.tTE):Ri(e,"tTE",ta(x,"Transition"),n),w=e.tAE?ki(e.tAE):Ri(e,"tAE",ta(b,"Animation"),n),M=m.console&&"function"==typeof m.console.warn,T=["container","controlsContainer","prevButton","nextButton","navContainer","autoplayButton"],E={};if(T.forEach(function(t){if("string"==typeof H[t]){var e=H[t],n=O.querySelector(e);if(E[t]=e,!n||!n.nodeName)return void(M&&console.warn("Can't find",H[t]));H[t]=n}}),!(H.container.children.length<1)){var k=H.responsive,R=H.nested,I="carousel"===H.mode;if(k){0 in k&&(H=Di(H,k[0]),delete k[0]);var A={};for(var N in k){var L=k[N];L="number"==typeof L?{items:L}:L,A[N]=L}k=A,A=null}if(I||function t(e){for(var n in e)I||("slideBy"===n&&(e[n]="page"),"edgePadding"===n&&(e[n]=!1),"autoHeight"===n&&(e[n]=!1)),"responsive"===n&&t(e[n])}(H),!I){H.axis="horizontal",H.slideBy="page",H.edgePadding=!1;var P=H.animateIn,z=H.animateOut,B=H.animateDelay,W=H.animateNormal}var S,q,F="horizontal"===H.axis,j=O.createElement("div"),V=O.createElement("div"),G=H.container,Q=G.parentNode,X=G.outerHTML,Y=G.children,K=Y.length,J=cn(),U=!1;k&&Sn(),I&&(G.className+=" tns-vpfix");var _,Z,$,tt,et,nt,it,at,rt=H.autoWidth,ot=pn("fixedWidth"),ut=pn("edgePadding"),lt=pn("gutter"),st=dn(),ct=pn("center"),ft=rt?1:Math.floor(pn("items")),dt=pn("slideBy"),vt=H.viewportMax||H.fixedWidthViewportWidth,pt=pn("arrowKeys"),ht=pn("speed"),mt=H.rewind,yt=!mt&&H.loop,gt=pn("autoHeight"),xt=pn("controls"),bt=pn("controlsText"),Ct=pn("nav"),wt=pn("touch"),Mt=pn("mouseDrag"),Tt=pn("autoplay"),Et=pn("autoplayTimeout"),At=pn("autoplayText"),Nt=pn("autoplayHoverPause"),Lt=pn("autoplayResetOnVisibility"),Bt=(at=document.createElement("style"),it&&at.setAttribute("media",it),document.querySelector("head").appendChild(at),at.sheet?at.sheet:at.styleSheet),St=H.lazyload,Ht=H.lazyloadSelector,Ot=[],Dt=yt?(et=function(){{if(rt||ot&&!vt)return K-1;var t=ot?"fixedWidth":"items",e=[];if((ot||H[t]<K)&&e.push(H[t]),k)for(var n in k){var i=k[n][t];i&&(ot||i<K)&&e.push(i)}return e.length||e.push(0),Math.ceil(ot?vt/Math.min.apply(null,e):Math.max.apply(null,e))}}(),nt=I?Math.ceil((5*et-K)/2):4*et-K,nt=Math.max(et,nt),vn("edgePadding")?nt+1:nt):0,kt=I?K+2*Dt:K+Dt,Rt=!(!ot&&!rt||yt),It=ot?ni():null,Pt=!I||!yt,zt=F?"left":"top",Wt="",qt="",Ft=ot?function(){return ct&&!yt?K-1:Math.ceil(-It/(ot+lt))}:rt?function(){for(var t=kt;t--;)if(_[t]>=-It)return t}:function(){return ct&&I&&!yt?K-1:yt||I?Math.max(0,kt-Math.ceil(ft)):kt-1},jt=un(pn("startIndex")),Vt=jt,Gt=(on(),0),Qt=rt?null:Ft(),Xt=H.preventActionWhenRunning,Yt=H.swipeAngle,Kt=!Yt||"?",Jt=!1,Ut=H.onInit,_t=new ia,Zt=" tns-slider tns-"+H.mode,$t=G.id||(tt=window.tnsId,window.tnsId=tt?tt+1:1,"tns"+window.tnsId),te=pn("disable"),ee=!1,ne=H.freezable,ie=!(!ne||rt)&&Bn(),ae=!1,re={click:fi,keydown:function(t){t=xi(t);var e=[a.LEFT,a.RIGHT].indexOf(t.keyCode);0<=e&&(0===e?Ae.disabled||fi(t,-1):Ne.disabled||fi(t,1))}},oe={click:function(t){if(Jt){if(Xt)return;si()}var e=bi(t=xi(t));for(;e!==He&&!Qi(e,"data-nav");)e=e.parentNode;if(Qi(e,"data-nav")){var n=Re=Number(Xi(e,"data-nav")),i=ot||rt?n*K/De:n*ft,a=pe?n:Math.min(Math.ceil(i),K-1);ci(a,t),Ie===n&&(je&&mi(),Re=-1)}},keydown:function(t){t=xi(t);var e=O.activeElement;if(!Qi(e,"data-nav"))return;var n=[a.LEFT,a.RIGHT,a.ENTER,a.SPACE].indexOf(t.keyCode),i=Number(Xi(e,"data-nav"));0<=n&&(0===n?0<i&&gi(Se[i-1]):1===n?i<De-1&&gi(Se[i+1]):ci(Re=i,t))}},ue={mouseover:function(){je&&(vi(),Ve=!0)},mouseout:function(){Ve&&(di(),Ve=!1)}},le={visibilitychange:function(){O.hidden?je&&(vi(),Qe=!0):Qe&&(di(),Qe=!1)}},se={keydown:function(t){t=xi(t);var e=[a.LEFT,a.RIGHT].indexOf(t.keyCode);0<=e&&fi(t,0===e?-1:1)}},ce={touchstart:Ti,touchmove:Ei,touchend:Ai,touchcancel:Ai},fe={mousedown:Ti,mousemove:Ei,mouseup:Ai,mouseleave:Ai},de=vn("controls"),ve=vn("nav"),pe=!!rt||H.navAsThumbnails,he=vn("autoplay"),me=vn("touch"),ye=vn("mouseDrag"),ge="tns-slide-active",xe="tns-complete",be={load:function(t){Wn(bi(t))},error:function(t){e=bi(t),Vi(e,"failed"),qn(e);var e}},Ce="force"===H.preventScrollOnTouch;if(de)var we,Me,Te=H.controlsContainer,Ee=H.controlsContainer?H.controlsContainer.outerHTML:"",Ae=H.prevButton,Ne=H.nextButton,Le=H.prevButton?H.prevButton.outerHTML:"",Be=H.nextButton?H.nextButton.outerHTML:"";if(ve)var Se,He=H.navContainer,Oe=H.navContainer?H.navContainer.outerHTML:"",De=rt?K:Li(),ke=0,Re=-1,Ie=sn(),Pe=Ie,ze="tns-nav-active",We="Carousel Page ",qe=" (Current Slide)";if(he)var Fe,je,Ve,Ge,Qe,Xe="forward"===H.autoplayDirection?1:-1,Ye=H.autoplayButton,Ke=H.autoplayButton?H.autoplayButton.outerHTML:"",Je=["<span class='tns-visually-hidden'>"," animation</span>"];if(me||ye)var Ue,_e,Ze={},$e={},tn=!1,en=F?function(t,e){return t.x-e.x}:function(t,e){return t.y-e.y};rt||rn(te||ie),d&&(zt=d,Wt="translate",v?(Wt+=F?"3d(":"3d(0px, ",qt=F?", 0px, 0px)":", 0px)"):(Wt+=F?"X(":"Y(",qt=")")),I&&(G.className=G.className.replace("tns-vpfix","")),function(){vn("gutter");j.className="tns-outer",V.className="tns-inner",j.id=$t+"-ow",V.id=$t+"-iw",""===G.id&&(G.id=$t);Zt+=g||rt?" tns-subpixel":" tns-no-subpixel",Zt+=y?" tns-calc":" tns-no-calc",rt&&(Zt+=" tns-autowidth");Zt+=" tns-"+H.axis,G.className+=Zt,I?((S=O.createElement("div")).id=$t+"-mw",S.className="tns-ovh",j.appendChild(S),S.appendChild(V)):j.appendChild(V);if(gt){var t=S||V;t.className+=" tns-ah"}if(Q.insertBefore(j,G),V.appendChild(G),Fi(Y,function(t,e){Vi(t,"tns-item"),t.id||(t.id=$t+"-item"+e),!I&&W&&Vi(t,W),Yi(t,{"aria-hidden":"true",tabindex:"-1"})}),Dt){for(var e=O.createDocumentFragment(),n=O.createDocumentFragment(),i=Dt;i--;){var a=i%K,r=Y[a].cloneNode(!0);if(Ki(r,"id"),n.insertBefore(r,n.firstChild),I){var o=Y[K-1-a].cloneNode(!0);Ki(o,"id"),e.appendChild(o)}}G.insertBefore(e,G.firstChild),G.appendChild(n),Y=G.children}}(),function(){if(!I)for(var t=jt,e=jt+Math.min(K,ft);t<e;t++){var n=Y[t];n.style.left=100*(t-jt)/ft+"%",Vi(n,P),Gi(n,W)}F&&(g||rt?(Wi(Bt,"#"+$t+" > .tns-item","font-size:"+m.getComputedStyle(Y[0]).fontSize+";",qi(Bt)),Wi(Bt,"#"+$t,"font-size:0;",qi(Bt))):I&&Fi(Y,function(t,e){var n;t.style.marginLeft=(n=e,y?y+"("+100*n+"% / "+kt+")":100*n/kt+"%")}));if(D){if(x){var i=S&&H.autoHeight?bn(H.speed):"";Wi(Bt,"#"+$t+"-mw",i,qi(Bt))}i=hn(H.edgePadding,H.gutter,H.fixedWidth,H.speed,H.autoHeight),Wi(Bt,"#"+$t+"-iw",i,qi(Bt)),I&&(i=F&&!rt?"width:"+mn(H.fixedWidth,H.gutter,H.items)+";":"",x&&(i+=bn(ht)),Wi(Bt,"#"+$t,i,qi(Bt))),i=F&&!rt?yn(H.fixedWidth,H.gutter,H.items):"",H.gutter&&(i+=gn(H.gutter)),I||(x&&(i+=bn(ht)),b&&(i+=Cn(ht))),i&&Wi(Bt,"#"+$t+" > .tns-item",i,qi(Bt))}else{I&&gt&&(S.style[x]=ht/1e3+"s"),V.style.cssText=hn(ut,lt,ot,gt),I&&F&&!rt&&(G.style.width=mn(ot,lt,ft));var i=F&&!rt?yn(ot,lt,ft):"";lt&&(i+=gn(lt)),i&&Wi(Bt,"#"+$t+" > .tns-item",i,qi(Bt))}if(k&&D)for(var a in k){a=parseInt(a);var r=k[a],i="",o="",u="",l="",s="",c=rt?null:pn("items",a),f=pn("fixedWidth",a),d=pn("speed",a),v=pn("edgePadding",a),p=pn("autoHeight",a),h=pn("gutter",a);x&&S&&pn("autoHeight",a)&&"speed"in r&&(o="#"+$t+"-mw{"+bn(d)+"}"),("edgePadding"in r||"gutter"in r)&&(u="#"+$t+"-iw{"+hn(v,h,f,d,p)+"}"),I&&F&&!rt&&("fixedWidth"in r||"items"in r||ot&&"gutter"in r)&&(l="width:"+mn(f,h,c)+";"),x&&"speed"in r&&(l+=bn(d)),l&&(l="#"+$t+"{"+l+"}"),("fixedWidth"in r||ot&&"gutter"in r||!I&&"items"in r)&&(s+=yn(f,h,c)),"gutter"in r&&(s+=gn(h)),!I&&"speed"in r&&(x&&(s+=bn(d)),b&&(s+=Cn(d))),s&&(s="#"+$t+" > .tns-item{"+s+"}"),(i=o+u+l+s)&&Bt.insertRule("@media (min-width: "+a/16+"em) {"+i+"}",Bt.cssRules.length)}}(),wn();var nn=yt?I?function(){var t=Gt,e=Qt;t+=dt,e-=dt,ut?(t+=1,e-=1):ot&&(st+lt)%(ot+lt)&&(e-=1),Dt&&(e<jt?jt-=K:jt<t&&(jt+=K))}:function(){if(Qt<jt)for(;Gt+K<=jt;)jt-=K;else if(jt<Gt)for(;jt<=Qt-K;)jt+=K}:function(){jt=Math.max(Gt,Math.min(Qt,jt))},an=I?function(){var e,n,i,a,t,r,o,u,l,s,c;ti(G,""),x||!ht?(ri(),ht&&Zi(G)||si()):(e=G,n=zt,i=Wt,a=qt,t=ii(),r=ht,o=si,u=Math.min(r,10),l=0<=t.indexOf("%")?"%":"px",t=t.replace(l,""),s=Number(e.style[n].replace(i,"").replace(a,"").replace(l,"")),c=(t-s)/r*u,setTimeout(function t(){r-=u,s+=c,e.style[n]=i+s+l+a,0<r?setTimeout(t,u):o()},u)),F||Ni()}:function(){Ot=[];var t={};t[C]=t[w]=si,na(Y[Vt],t),ea(Y[jt],t),oi(Vt,P,z,!0),oi(jt,W,P),C&&w&&ht&&Zi(G)||si()};return{version:"2.9.2",getInfo:Si,events:_t,goTo:ci,play:function(){Tt&&!je&&(hi(),Ge=!1)},pause:function(){je&&(mi(),Ge=!0)},isOn:U,updateSliderHeight:Xn,refresh:wn,destroy:function(){if(Bt.disabled=!0,Bt.ownerNode&&Bt.ownerNode.remove(),na(m,{resize:Nn}),pt&&na(O,se),Te&&na(Te,re),He&&na(He,oe),na(G,ue),na(G,le),Ye&&na(Ye,{click:yi}),Tt&&clearInterval(Fe),I&&C){var t={};t[C]=si,na(G,t)}wt&&na(G,ce),Mt&&na(G,fe);var r=[X,Ee,Le,Be,Oe,Ke];for(var e in T.forEach(function(t,e){var n="container"===t?j:H[t];if("object"==typeof n&&n){var i=!!n.previousElementSibling&&n.previousElementSibling,a=n.parentNode;n.outerHTML=r[e],H[t]=i?i.nextElementSibling:a.firstElementChild}}),T=P=z=B=W=F=j=V=G=Q=X=Y=K=q=J=rt=ot=ut=lt=st=ft=dt=vt=pt=ht=mt=yt=gt=Bt=St=_=Ot=Dt=kt=Rt=It=Pt=zt=Wt=qt=Ft=jt=Vt=Gt=Qt=Yt=Kt=Jt=Ut=_t=Zt=$t=te=ee=ne=ie=ae=re=oe=ue=le=se=ce=fe=de=ve=pe=he=me=ye=ge=xe=be=Z=xt=bt=Te=Ee=Ae=Ne=we=Me=Ct=He=Oe=Se=De=ke=Re=Ie=Pe=ze=We=qe=Tt=Et=Xe=At=Nt=Ye=Ke=Lt=Je=Fe=je=Ve=Ge=Qe=Ze=$e=Ue=tn=_e=en=wt=Mt=null,this)"rebuild"!==e&&(this[e]=null);U=!1},rebuild:function(){return aa(Di(H,E))}}}function rn(t){t&&(xt=Ct=wt=Mt=pt=Tt=Nt=Lt=!1)}function on(){for(var t=I?jt-Dt:jt;t<0;)t+=K;return t%K+1}function un(t){return t=t?Math.max(0,Math.min(yt?K-1:K-ft,t)):0,I?t+Dt:t}function ln(t){for(null==t&&(t=jt),I&&(t-=Dt);t<0;)t+=K;return Math.floor(t%K)}function sn(){var t,e=ln();return t=pe?e:ot||rt?Math.ceil((e+1)*De/K-1):Math.floor(e/ft),!yt&&I&&jt===Qt&&(t=De-1),t}function cn(){return m.innerWidth||O.documentElement.clientWidth||O.body.clientWidth}function fn(t){return"top"===t?"afterbegin":"beforeend"}function dn(){var t=ut?2*ut-lt:0;return function t(e){if(null!=e){var n,i,a=O.createElement("div");return e.appendChild(a),i=(n=a.getBoundingClientRect()).right-n.left,a.remove(),i||t(e.parentNode)}}(Q)-t}function vn(t){if(H[t])return!0;if(k)for(var e in k)if(k[e][t])return!0;return!1}function pn(t,e){if(null==e&&(e=J),"items"===t&&ot)return Math.floor((st+lt)/(ot+lt))||1;var n=H[t];if(k)for(var i in k)e>=parseInt(i)&&t in k[i]&&(n=k[i][t]);return"slideBy"===t&&"page"===n&&(n=pn("items")),I||"slideBy"!==t&&"items"!==t||(n=Math.floor(n)),n}function hn(t,e,n,i,a){var r="";if(void 0!==t){var o=t;e&&(o-=e),r=F?"margin: 0 "+o+"px 0 "+t+"px;":"margin: "+t+"px 0 "+o+"px 0;"}else if(e&&!n){var u="-"+e+"px";r="margin: 0 "+(F?u+" 0 0":"0 "+u+" 0")+";"}return!I&&a&&x&&i&&(r+=bn(i)),r}function mn(t,e,n){return t?(t+e)*kt+"px":y?y+"("+100*kt+"% / "+n+")":100*kt/n+"%"}function yn(t,e,n){var i;if(t)i=t+e+"px";else{I||(n=Math.floor(n));var a=I?kt:n;i=y?y+"(100% / "+a+")":100/a+"%"}return i="width:"+i,"inner"!==R?i+";":i+" !important;"}function gn(t){var e="";!1!==t&&(e=(F?"padding-":"margin-")+(F?"right":"bottom")+": "+t+"px;");return e}function xn(t,e){var n=t.substring(0,t.length-e).toLowerCase();return n&&(n="-"+n+"-"),n}function bn(t){return xn(x,18)+"transition-duration:"+t/1e3+"s;"}function Cn(t){return xn(b,17)+"animation-duration:"+t/1e3+"s;"}function wn(){if(vn("autoHeight")||rt||!F){var t=G.querySelectorAll("img");Fi(t,function(t){var e=t.src;St||(e&&e.indexOf("data:image")<0?(t.src="",ea(t,be),Vi(t,"loading"),t.src=e):Wn(t))}),Hi(function(){Vn(Ji(t),function(){Z=!0})}),vn("autoHeight")&&(t=Fn(jt,Math.min(jt+ft-1,kt-1))),St?Mn():Hi(function(){Vn(Ji(t),Mn)})}else I&&ai(),En(),An()}function Mn(){if(rt){var i=yt?jt:K-1;!function t(){var e=Y[i].getBoundingClientRect().left,n=Y[i-1].getBoundingClientRect().right;Math.abs(e-n)<=1?Tn():setTimeout(function(){t()},16)}()}else Tn()}function Tn(){F&&!rt||(Yn(),rt?(It=ni(),ne&&(ie=Bn()),Qt=Ft(),rn(te||ie)):Ni()),I&&ai(),En(),An()}function En(){if(Kn(),j.insertAdjacentHTML("afterbegin",'<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">'+In()+"</span>  of "+K+"</div>"),$=j.querySelector(".tns-liveregion .current"),he){var t=Tt?"stop":"start";Ye?Yi(Ye,{"data-action":t}):H.autoplayButtonOutput&&(j.insertAdjacentHTML(fn(H.autoplayPosition),'<button type="button" data-action="'+t+'">'+Je[0]+t+Je[1]+At[0]+"</button>"),Ye=j.querySelector("[data-action]")),Ye&&ea(Ye,{click:yi}),Tt&&(hi(),Nt&&ea(G,ue),Lt&&ea(G,le))}if(ve){if(He)Yi(He,{"aria-label":"Carousel Pagination"}),Fi(Se=He.children,function(t,e){Yi(t,{"data-nav":e,tabindex:"-1","aria-label":We+(e+1),"aria-controls":$t})});else{for(var e="",n=pe?"":'style="display:none"',i=0;i<K;i++)e+='<button type="button" data-nav="'+i+'" tabindex="-1" aria-controls="'+$t+'" '+n+' aria-label="'+We+(i+1)+'"></button>';e='<div class="tns-nav" aria-label="Carousel Pagination">'+e+"</div>",j.insertAdjacentHTML(fn(H.navPosition),e),He=j.querySelector(".tns-nav"),Se=He.children}if(Bi(),x){var a=x.substring(0,x.length-18).toLowerCase(),r="transition: all "+ht/1e3+"s";a&&(r="-"+a+"-"+r),Wi(Bt,"[aria-controls^="+$t+"-item]",r,qi(Bt))}Yi(Se[Ie],{"aria-label":We+(Ie+1)+qe}),Ki(Se[Ie],"tabindex"),Vi(Se[Ie],ze),ea(He,oe)}de&&(Te||Ae&&Ne||(j.insertAdjacentHTML(fn(H.controlsPosition),'<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="'+$t+'">'+bt[0]+'</button><button type="button" data-controls="next" tabindex="-1" aria-controls="'+$t+'">'+bt[1]+"</button></div>"),Te=j.querySelector(".tns-controls")),Ae&&Ne||(Ae=Te.children[0],Ne=Te.children[1]),H.controlsContainer&&Yi(Te,{"aria-label":"Carousel Navigation",tabindex:"0"}),(H.controlsContainer||H.prevButton&&H.nextButton)&&Yi([Ae,Ne],{"aria-controls":$t,tabindex:"-1"}),(H.controlsContainer||H.prevButton&&H.nextButton)&&(Yi(Ae,{"data-controls":"prev"}),Yi(Ne,{"data-controls":"next"})),we=Un(Ae),Me=Un(Ne),$n(),Te?ea(Te,re):(ea(Ae,re),ea(Ne,re))),Hn()}function An(){if(I&&C){var t={};t[C]=si,ea(G,t)}wt&&ea(G,ce,H.preventScrollOnTouch),Mt&&ea(G,fe),pt&&ea(O,se),"inner"===R?_t.on("outerResized",function(){Ln(),_t.emit("innerLoaded",Si())}):(k||ot||rt||gt||!F)&&ea(m,{resize:Nn}),gt&&("outer"===R?_t.on("innerLoaded",jn):te||jn()),zn(),te?kn():ie&&Dn(),_t.on("indexChanged",Gn),"inner"===R&&_t.emit("innerLoaded",Si()),"function"==typeof Ut&&Ut(Si()),U=!0}function Nn(t){Hi(function(){Ln(xi(t))})}function Ln(t){if(U){"outer"===R&&_t.emit("outerResized",Si(t)),J=cn();var e,n=q,i=!1;k&&(Sn(),(e=n!==q)&&_t.emit("newBreakpointStart",Si(t)));var a,r,o,u,l=ft,s=te,c=ie,f=pt,d=xt,v=Ct,p=wt,h=Mt,m=Tt,y=Nt,g=Lt,x=jt;if(e){var b=ot,C=gt,w=bt,M=ct,T=At;if(!D)var E=lt,A=ut}if(pt=pn("arrowKeys"),xt=pn("controls"),Ct=pn("nav"),wt=pn("touch"),ct=pn("center"),Mt=pn("mouseDrag"),Tt=pn("autoplay"),Nt=pn("autoplayHoverPause"),Lt=pn("autoplayResetOnVisibility"),e&&(te=pn("disable"),ot=pn("fixedWidth"),ht=pn("speed"),gt=pn("autoHeight"),bt=pn("controlsText"),At=pn("autoplayText"),Et=pn("autoplayTimeout"),D||(ut=pn("edgePadding"),lt=pn("gutter"))),rn(te),st=dn(),F&&!rt||te||(Yn(),F||(Ni(),i=!0)),(ot||rt)&&(It=ni(),Qt=Ft()),(e||ot)&&(ft=pn("items"),dt=pn("slideBy"),(r=ft!==l)&&(ot||rt||(Qt=Ft()),nn())),e&&te!==s&&(te?kn():function(){if(!ee)return;if(Bt.disabled=!1,G.className+=Zt,ai(),yt)for(var t=Dt;t--;)I&&_i(Y[t]),_i(Y[kt-t-1]);if(!I)for(var e=jt,n=jt+K;e<n;e++){var i=Y[e],a=e<jt+ft?P:W;i.style.left=100*(e-jt)/ft+"%",Vi(i,a)}On(),ee=!1}()),ne&&(e||ot||rt)&&(ie=Bn())!==c&&(ie?(ri(ii(un(0))),Dn()):(!function(){if(!ae)return;ut&&D&&(V.style.margin="");if(Dt)for(var t="tns-transparent",e=Dt;e--;)I&&Gi(Y[e],t),Gi(Y[kt-e-1],t);On(),ae=!1}(),i=!0)),rn(te||ie),Tt||(Nt=Lt=!1),pt!==f&&(pt?ea(O,se):na(O,se)),xt!==d&&(xt?Te?_i(Te):(Ae&&_i(Ae),Ne&&_i(Ne)):Te?Ui(Te):(Ae&&Ui(Ae),Ne&&Ui(Ne))),Ct!==v&&(Ct?_i(He):Ui(He)),wt!==p&&(wt?ea(G,ce,H.preventScrollOnTouch):na(G,ce)),Mt!==h&&(Mt?ea(G,fe):na(G,fe)),Tt!==m&&(Tt?(Ye&&_i(Ye),je||Ge||hi()):(Ye&&Ui(Ye),je&&mi())),Nt!==y&&(Nt?ea(G,ue):na(G,ue)),Lt!==g&&(Lt?ea(O,le):na(O,le)),e){if(ot===b&&ct===M||(i=!0),gt!==C&&(gt||(V.style.height="")),xt&&bt!==w&&(Ae.innerHTML=bt[0],Ne.innerHTML=bt[1]),Ye&&At!==T){var N=Tt?1:0,L=Ye.innerHTML,B=L.length-T[N].length;L.substring(B)===T[N]&&(Ye.innerHTML=L.substring(0,B)+At[N])}}else ct&&(ot||rt)&&(i=!0);if((r||ot&&!rt)&&(De=Li(),Bi()),(a=jt!==x)?(_t.emit("indexChanged",Si()),i=!0):r?a||Gn():(ot||rt)&&(zn(),Kn(),Rn()),r&&!I&&function(){for(var t=jt+Math.min(K,ft),e=kt;e--;){var n=Y[e];jt<=e&&e<t?(Vi(n,"tns-moving"),n.style.left=100*(e-jt)/ft+"%",Vi(n,P),Gi(n,W)):n.style.left&&(n.style.left="",Vi(n,W),Gi(n,P)),Gi(n,z)}setTimeout(function(){Fi(Y,function(t){Gi(t,"tns-moving")})},300)}(),!te&&!ie){if(e&&!D&&(ut===A&&lt===E||(V.style.cssText=hn(ut,lt,ot,ht,gt)),F)){I&&(G.style.width=mn(ot,lt,ft));var S=yn(ot,lt,ft)+gn(lt);u=qi(o=Bt)-1,"deleteRule"in o?o.deleteRule(u):o.removeRule(u),Wi(Bt,"#"+$t+" > .tns-item",S,qi(Bt))}gt&&jn(),i&&(ai(),Vt=jt)}e&&_t.emit("newBreakpointEnd",Si(t))}}function Bn(){if(!ot&&!rt)return K<=(ct?ft-(ft-1)/2:ft);var t=ot?(ot+lt)*K:_[K],e=ut?st+2*ut:st+lt;return ct&&(e-=ot?(st-ot)/2:(st-(_[jt+1]-_[jt]-lt))/2),t<=e}function Sn(){for(var t in q=0,k)(t=parseInt(t))<=J&&(q=t)}function Hn(){!Tt&&Ye&&Ui(Ye),!Ct&&He&&Ui(He),xt||(Te?Ui(Te):(Ae&&Ui(Ae),Ne&&Ui(Ne)))}function On(){Tt&&Ye&&_i(Ye),Ct&&He&&_i(He),xt&&(Te?_i(Te):(Ae&&_i(Ae),Ne&&_i(Ne)))}function Dn(){if(!ae){if(ut&&(V.style.margin="0px"),Dt)for(var t="tns-transparent",e=Dt;e--;)I&&Vi(Y[e],t),Vi(Y[kt-e-1],t);Hn(),ae=!0}}function kn(){if(!ee){if(Bt.disabled=!0,G.className=G.className.replace(Zt.substring(1),""),Ki(G,["style"]),yt)for(var t=Dt;t--;)I&&Ui(Y[t]),Ui(Y[kt-t-1]);if(F&&I||Ki(V,["style"]),!I)for(var e=jt,n=jt+K;e<n;e++){var i=Y[e];Ki(i,["style"]),Gi(i,P),Gi(i,W)}Hn(),ee=!0}}function Rn(){var t=In();$.innerHTML!==t&&($.innerHTML=t)}function In(){var t=Pn(),e=t[0]+1,n=t[1]+1;return e===n?e+"":e+" to "+n}function Pn(t){null==t&&(t=ii());var n,i,a,r=jt;if(ct||ut?(rt||ot)&&(i=-(parseFloat(t)+ut),a=i+st+2*ut):rt&&(i=_[jt],a=i+st),rt)_.forEach(function(t,e){e<kt&&((ct||ut)&&t<=i+.5&&(r=e),.5<=a-t&&(n=e))});else{if(ot){var e=ot+lt;ct||ut?(r=Math.floor(i/e),n=Math.ceil(a/e-1)):n=r+Math.ceil(st/e)-1}else if(ct||ut){var o=ft-1;if(ct?(r-=o/2,n=jt+o/2):n=jt+o,ut){var u=ut*ft/st;r-=u,n+=u}r=Math.floor(r),n=Math.ceil(n)}else n=r+ft-1;r=Math.max(r,0),n=Math.min(n,kt-1)}return[r,n]}function zn(){if(St&&!te){var t=Pn();t.push(Ht),Fn.apply(null,t).forEach(function(t){if(!ji(t,xe)){var e={};e[C]=function(t){t.stopPropagation()},ea(t,e),ea(t,be),t.src=Xi(t,"data-src");var n=Xi(t,"data-srcset");n&&(t.srcset=n),Vi(t,"loading")}})}}function Wn(t){Vi(t,"loaded"),qn(t)}function qn(t){Vi(t,xe),Gi(t,"loading"),na(t,be)}function Fn(t,e,n){var i=[];for(n||(n="img");t<=e;)Fi(Y[t].querySelectorAll(n),function(t){i.push(t)}),t++;return i}function jn(){var t=Fn.apply(null,Pn());Hi(function(){Vn(t,Xn)})}function Vn(n,t){return Z?t():(n.forEach(function(t,e){!St&&t.complete&&qn(t),ji(t,xe)&&n.splice(e,1)}),n.length?void Hi(function(){Vn(n,t)}):t())}function Gn(){zn(),Kn(),Rn(),$n(),function(){if(Ct&&(Ie=0<=Re?Re:sn(),Re=-1,Ie!==Pe)){var t=Se[Pe],e=Se[Ie];Yi(t,{tabindex:"-1","aria-label":We+(Pe+1)}),Gi(t,ze),Yi(e,{"aria-label":We+(Ie+1)+qe}),Ki(e,"tabindex"),Vi(e,ze),Pe=Ie}}()}function Qn(t,e){for(var n=[],i=t,a=Math.min(t+e,kt);i<a;i++)n.push(Y[i].offsetHeight);return Math.max.apply(null,n)}function Xn(){var t=gt?Qn(jt,ft):Qn(Dt,K),e=S||V;e.style.height!==t&&(e.style.height=t+"px")}function Yn(){_=[0];var n=F?"left":"top",i=F?"right":"bottom",a=Y[0].getBoundingClientRect()[n];Fi(Y,function(t,e){e&&_.push(t.getBoundingClientRect()[n]-a),e===kt-1&&_.push(t.getBoundingClientRect()[i]-a)})}function Kn(){var t=Pn(),n=t[0],i=t[1];Fi(Y,function(t,e){n<=e&&e<=i?Qi(t,"aria-hidden")&&(Ki(t,["aria-hidden","tabindex"]),Vi(t,ge)):Qi(t,"aria-hidden")||(Yi(t,{"aria-hidden":"true",tabindex:"-1"}),Gi(t,ge))})}function Jn(t){return t.nodeName.toLowerCase()}function Un(t){return"button"===Jn(t)}function _n(t){return"true"===t.getAttribute("aria-disabled")}function Zn(t,e,n){t?e.disabled=n:e.setAttribute("aria-disabled",n.toString())}function $n(){if(xt&&!mt&&!yt){var t=we?Ae.disabled:_n(Ae),e=Me?Ne.disabled:_n(Ne),n=jt<=Gt,i=!mt&&Qt<=jt;n&&!t&&Zn(we,Ae,!0),!n&&t&&Zn(we,Ae,!1),i&&!e&&Zn(Me,Ne,!0),!i&&e&&Zn(Me,Ne,!1)}}function ti(t,e){x&&(t.style[x]=e)}function ei(t){return null==t&&(t=jt),rt?(st-(ut?lt:0)-(_[t+1]-_[t]-lt))/2:ot?(st-ot)/2:(ft-1)/2}function ni(){var t=st+(ut?lt:0)-(ot?(ot+lt)*kt:_[kt]);return ct&&!yt&&(t=ot?-(ot+lt)*(kt-1)-ei():ei(kt-1)-_[kt-1]),0<t&&(t=0),t}function ii(t){var e;if(null==t&&(t=jt),F&&!rt)if(ot)e=-(ot+lt)*t,ct&&(e+=ei());else{var n=d?kt:ft;ct&&(t-=ei()),e=100*-t/n}else e=-_[t],ct&&rt&&(e+=ei());return Rt&&(e=Math.max(e,It)),e+=!F||rt||ot?"px":"%"}function ai(t){ti(G,"0s"),ri(t)}function ri(t){null==t&&(t=ii()),G.style[zt]=Wt+t+qt}function oi(t,e,n,i){var a=t+ft;yt||(a=Math.min(a,kt));for(var r=t;r<a;r++){var o=Y[r];i||(o.style.left=100*(r-jt)/ft+"%"),B&&p&&(o.style[p]=o.style[h]=B*(r-t)/1e3+"s"),Gi(o,e),Vi(o,n),i&&Ot.push(o)}}function ui(t,e){Pt&&nn(),(jt!==Vt||e)&&(_t.emit("indexChanged",Si()),_t.emit("transitionStart",Si()),gt&&jn(),je&&t&&0<=["click","keydown"].indexOf(t.type)&&mi(),Jt=!0,an())}function li(t){return t.toLowerCase().replace(/-/g,"")}function si(t){if(I||Jt){if(_t.emit("transitionEnd",Si(t)),!I&&0<Ot.length)for(var e=0;e<Ot.length;e++){var n=Ot[e];n.style.left="",h&&p&&(n.style[h]="",n.style[p]=""),Gi(n,z),Vi(n,W)}if(!t||!I&&t.target.parentNode===G||t.target===G&&li(t.propertyName)===li(zt)){if(!Pt){var i=jt;nn(),jt!==i&&(_t.emit("indexChanged",Si()),ai())}"inner"===R&&_t.emit("innerLoaded",Si()),Jt=!1,Vt=jt}}}function ci(t,e){if(!ie)if("prev"===t)fi(e,-1);else if("next"===t)fi(e,1);else{if(Jt){if(Xt)return;si()}var n=ln(),i=0;if("first"===t?i=-n:"last"===t?i=I?K-ft-n:K-1-n:("number"!=typeof t&&(t=parseInt(t)),isNaN(t)||(e||(t=Math.max(0,Math.min(K-1,t))),i=t-n)),!I&&i&&Math.abs(i)<ft){var a=0<i?1:-1;i+=Gt<=jt+i-K?K*a:2*K*a*-1}jt+=i,I&&yt&&(jt<Gt&&(jt+=K),Qt<jt&&(jt-=K)),ln(jt)!==ln(Vt)&&ui(e)}}function fi(t,e){if(Jt){if(Xt)return;si()}var n;if(!e){for(var i=bi(t=xi(t));i!==Te&&[Ae,Ne].indexOf(i)<0;)i=i.parentNode;var a=[Ae,Ne].indexOf(i);0<=a&&(n=!0,e=0===a?-1:1)}if(mt){if(jt===Gt&&-1===e)return void ci("last",t);if(jt===Qt&&1===e)return void ci("first",t)}e&&(jt+=dt*e,rt&&(jt=Math.floor(jt)),ui(n||t&&"keydown"===t.type?t:null))}function di(){Fe=setInterval(function(){fi(null,Xe)},Et),je=!0}function vi(){clearInterval(Fe),je=!1}function pi(t,e){Yi(Ye,{"data-action":t}),Ye.innerHTML=Je[0]+t+Je[1]+e}function hi(){di(),Ye&&pi("stop",At[1])}function mi(){vi(),Ye&&pi("start",At[0])}function yi(){je?(mi(),Ge=!0):(hi(),Ge=!1)}function gi(t){t.focus()}function xi(t){return Ci(t=t||m.event)?t.changedTouches[0]:t}function bi(t){return t.target||m.event.srcElement}function Ci(t){return 0<=t.type.indexOf("touch")}function wi(t){t.preventDefault?t.preventDefault():t.returnValue=!1}function Mi(){return a=$e.y-Ze.y,r=$e.x-Ze.x,t=Math.atan2(a,r)*(180/Math.PI),e=Yt,n=!1,i=Math.abs(90-Math.abs(t)),90-e<=i?n="horizontal":i<=e&&(n="vertical"),n===H.axis;var t,e,n,i,a,r}function Ti(t){if(Jt){if(Xt)return;si()}Tt&&je&&vi(),tn=!0,_e&&(Oi(_e),_e=null);var e=xi(t);_t.emit(Ci(t)?"touchStart":"dragStart",Si(t)),!Ci(t)&&0<=["img","a"].indexOf(Jn(bi(t)))&&wi(t),$e.x=Ze.x=e.clientX,$e.y=Ze.y=e.clientY,I&&(Ue=parseFloat(G.style[zt].replace(Wt,"")),ti(G,"0s"))}function Ei(t){if(tn){var e=xi(t);$e.x=e.clientX,$e.y=e.clientY,I?_e||(_e=Hi(function(){!function t(e){if(!Kt)return void(tn=!1);Oi(_e);tn&&(_e=Hi(function(){t(e)}));"?"===Kt&&(Kt=Mi());if(Kt){!Ce&&Ci(e)&&(Ce=!0);try{e.type&&_t.emit(Ci(e)?"touchMove":"dragMove",Si(e))}catch(t){}var n=Ue,i=en($e,Ze);if(!F||ot||rt)n+=i,n+="px";else{var a=d?i*ft*100/((st+lt)*kt):100*i/(st+lt);n+=a,n+="%"}G.style[zt]=Wt+n+qt}}(t)})):("?"===Kt&&(Kt=Mi()),Kt&&(Ce=!0)),("boolean"!=typeof t.cancelable||t.cancelable)&&Ce&&t.preventDefault()}}function Ai(i){if(tn){_e&&(Oi(_e),_e=null),I&&ti(G,""),tn=!1;var t=xi(i);$e.x=t.clientX,$e.y=t.clientY;var a=en($e,Ze);if(Math.abs(a)){if(!Ci(i)){var n=bi(i);ea(n,{click:function t(e){wi(e),na(n,{click:t})}})}I?_e=Hi(function(){if(F&&!rt){var t=-a*ft/(st+lt);t=0<a?Math.floor(t):Math.ceil(t),jt+=t}else{var e=-(Ue+a);if(e<=0)jt=Gt;else if(e>=_[kt-1])jt=Qt;else for(var n=0;n<kt&&e>=_[n];)e>_[jt=n]&&a<0&&(jt+=1),n++}ui(i,a),_t.emit(Ci(i)?"touchEnd":"dragEnd",Si(i))}):Kt&&fi(i,0<a?-1:1)}}"auto"===H.preventScrollOnTouch&&(Ce=!1),Yt&&(Kt="?"),Tt&&!je&&di()}function Ni(){(S||V).style.height=_[jt+ft]-_[jt]+"px"}function Li(){var t=ot?(ot+lt)*K/st:K/ft;return Math.min(Math.ceil(t),K)}function Bi(){if(Ct&&!pe&&De!==ke){var t=ke,e=De,n=_i;for(De<ke&&(t=De,e=ke,n=Ui);t<e;)n(Se[t]),t++;ke=De}}function Si(t){return{container:G,slideItems:Y,navContainer:He,navItems:Se,controlsContainer:Te,hasControls:de,prevButton:Ae,nextButton:Ne,items:ft,slideBy:dt,cloneCount:Dt,slideCount:K,slideCountNew:kt,index:jt,indexCached:Vt,displayIndex:on(),navCurrentIndex:Ie,navCurrentIndexCached:Pe,pages:De,pagesCached:ke,sheet:Bt,isOn:U,event:t||{}}}M&&console.warn("No slides found in",H.container)};return aa}();
//# sourceMappingURL=../sourcemaps/tiny-slider.js.map